import { useCurrentAttendanceSession } from "_api/hooks/attendances";
import { useCurrentUser, useCurrentUserForProvider } from "_api/hooks/auth";
import { useQueueDeskToken } from "_api/hooks/queues";
import { Perms } from "_enums/Perms";
import { usePageTitle } from "_hooks";
import { AuthService } from "_services/auth.service";
import { UserDeskHub } from "_services/ws/user-desk-hub";
import { containPerms, hasPerm } from "_utils/perms";
import { useCallback, useEffect } from "react";

let isFetching = false;

export const UserDeskHubProvider = () => {
    if (!AuthService.isLoggedIn()) {
        return <></>;
    }

    return <CurrentUser />;
}

const CurrentUser = () => {
    const { user } = useCurrentUserForProvider() as any;

    if (!user.name
        || (user && (user.courts?.length < 1))) {
        return <></>;
    }


    if (!containPerms([Perms.DeskConfView], user.permissions || [])) {
        return <></>;
    }


    return <Provider />;
}

const Provider = () => {

    const { user } = useCurrentUser();

    const { attendanceSession } = useCurrentAttendanceSession();
    const { mutateAsync: request } = useQueueDeskToken();
    const loadOrFetch = useCallback(() => {
        if (isFetching) {
            return;
        }

        if (!UserDeskHub.loadGeneratedToken()) {
            (async () => {
                isFetching = true;
                const token = await request();
                UserDeskHub.storeGeneratedToken(token);
                isFetching = false;
            })()
        }
    }, [request]);

    useEffect(loadOrFetch, [user]);
    UserDeskHub.$onTokenReset.on(() => loadOrFetch());

    useEffect(() => {
        if (!attendanceSession?.start) {
            UserDeskHub.connectionStarted
                && UserDeskHub.disconnect();
            return;
        }

        if (!UserDeskHub.connectionStarted) {
            (async () => {
                await UserDeskHub.connect();
            })();
        }
    }, [attendanceSession]);

    return (<></>);
}
